import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const fr: Translations = {
  common: {
    appName: appName,
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    edit: 'Modifier',
    back: 'Retour',
    search: 'Rechercher',
    noResults: 'Aucun résultat',
    error: 'Une erreur est survenue',
    success: 'Succès',
  },
  header: {
    searchPlaceholder: 'Rechercher des cosers, hotgirls, ao dai, modèles...',
    searchPlaceholderMobile: 'Rechercher...',
    home: 'Accueil',
    hotgirl: 'Hotgirl',
    coser: 'Coser',
    model: 'Modèle',
    upload: 'Publier',
    notifications: 'Notifications',
    login: 'Se connecter',
    register: "S'inscrire",
  },
  footer: {
    tagline: `La meilleure plateforme de partage de photos de Coser, Hotgirl et Modèles sur ${appName}.`,
    copyright: `© {year} ${appName}. Tous droits réservés.`,
    sections: { explore: 'Explorer', account: 'Compte', support: 'Support' },
    links: {
      home: 'Accueil', hotgirl: 'Hotgirl', coser: 'Coser', model: 'Modèle', aoDai: 'Ao Dai',
      login: 'Se connecter', register: "S'inscrire", upload: 'Publier une photo', dashboard: 'Tableau de bord',
      terms: "Conditions d'utilisation", privacy: 'Confidentialité', report: 'Signaler une violation', contact: 'Contact',
    },
  },
  collections: {
    title: 'Collections',
    createAlbum: 'Créer un album',
    saved: 'Enregistrés',
    noSaved: "Aucune photo enregistrée pour l'instant",
    noSavedHint: 'Explorer les photos →',
    removedSave: 'Supprimé des enregistrements',
    createModalTitle: 'Créer un nouvel album',
    albumNamePlaceholder: "Nom de l'album...",
    cancel: 'Annuler',
    create: 'Créer',
    albumCreated: 'Album créé',
  },
  home: {
    title: 'Découvrez',
    titleHighlight: 'la beauté',
    titleSuffix: 'de la vie',
    subtitle: 'Des milliers de photos de Coser, Hotgirl et Modèles mises à jour chaque jour',
    sortNewest: 'Plus récents',
    sortTrending: 'Tendances',
    sortPopular: 'Populaires',
    allCategories: 'Tout',
    noMorePosts: 'Vous avez vu toutes les photos',
  },
  auth: {
    login: {
      title: 'Connectez-vous pour continuer',
      continueWithGoogle: 'Continuer avec Google',
      orLoginWithEmail: 'ou connectez-vous par e-mail',
      email: 'E-mail',
      password: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      submitButton: 'Se connecter',
      loading: 'Connexion en cours...',
      noAccount: "Vous n'avez pas de compte ?",
      registerLink: "S'inscrire maintenant",
      errorCredentials: 'E-mail ou mot de passe incorrect',
      successLogin: 'Connexion réussie !',
    },
    register: {
      title: 'Créer un compte gratuit',
      displayName: "Nom d'affichage",
      displayNamePlaceholder: 'Jean Dupont',
      email: 'E-mail',
      password: 'Mot de passe',
      passwordPlaceholder: 'Au moins 8 caractères',
      confirmPassword: 'Confirmer le mot de passe',
      submitButton: "S'inscrire",
      loading: 'Création du compte...',
      hasAccount: 'Vous avez déjà un compte ?',
      loginLink: 'Se connecter',
      errorPasswordMismatch: 'Les mots de passe ne correspondent pas',
      errorPasswordLength: 'Le mot de passe doit contenir au moins 8 caractères',
      errorGeneric: "Échec de l'inscription",
      successRegister: 'Inscription réussie !',
      emailTaken: 'Email déjà utilisé',
      serverError: 'Erreur serveur, veuillez réessayer plus tard',
    },
    forgotPassword: {
      title: 'Mot de passe oublié',
      subtitle: 'Entrez votre e-mail et nous vous enverrons un lien de réinitialisation',
      email: 'E-mail',
      submitButton: 'Envoyer le lien',
      backToLogin: 'Retour à la connexion',
      sending: 'Envoi en cours...',
      emailSent: 'Email envoyé !',
      checkEmail: 'Vérifiez la boîte de réception de {email} pour recevoir le lien de réinitialisation du mot de passe.',
      instructions: 'Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    },
  },
  userMenu: {
    dashboard: 'Tableau de bord',
    collections: 'Collections',
    settings: 'Paramètres',
    logout: 'Se déconnecter',
  },
  settings: {
    title: 'Paramètres du compte',
    profile: {
      nav: 'Profil',
      title: 'Informations du profil',
      displayName: "Nom d'affichage",
      username: "Nom d'utilisateur",
      website: 'Site web',
      bio: 'Bio',
      bioPlaceholder: 'Présentez-vous...',
      changeAvatar: "Changer l'avatar",
      avatarHint: 'JPG, PNG, WebP max 5 Mo',
      saveButton: 'Enregistrer les modifications',
      saving: 'Enregistrement...',
      savedSuccess: 'Modifications enregistrées',
    },
    password: { 
      nav: 'Mot de passe',
      title: 'Changer le mot de passe',
      fields: {
        currentPassword: 'Mot de passe actuel',
        newPassword: 'Nouveau mot de passe',
        confirm: 'Confirmer le nouveau mot de passe',
      },
      errors: {
        confirm: 'Le nouveau mot de passe ne correspond pas',
        minLength: 'Le mot de passe doit contenir au moins 8 caractères',
      },
      success: 'Mot de passe changé',
      saving: 'Enregistrement...',
      submit: 'Changer le mot de passe',
    },
    notifications: { 
      nav: 'Notifications',
      title: 'Paramètres de notification',
      options: {
        likes: 'Lorsque quelqu\'un aime votre photo',
        comments: 'Lorsque quelqu\'un comment',
        replies: 'Lorsque quelqu\'un répond à votre commentaire',
        follows: 'Lorsque quelqu\'un vous suit',
        approved: 'Lorsque le post est approuvé',
        email_digest: 'Résumé hebdomadaire par e-mail',
        marketing: 'Notifications de promotions et d\'événements',
      },
      saveSuccess: 'Les paramètres de notification ont été enregistrés',
      saving: 'Enregistrement...',
      saveButton: 'Enregistrer les paramètres',
    },
    security: { 
      nav: 'Sécurité',
      twoFactorAuth: 'Authentification à deux facteurs (2FA)',
      twoFactorAuthHint: 'Renforcez la sécurité avec un code de vérification de l\'application',
      comingSoon: 'À venir',
      activeSessions: 'Sessions actives',
      currentBrowser: 'Navigateur actuel',
      lastLogin: 'Dernière connexion',
      active: 'Actif',
      dangerZone: 'Zone de danger',
      deleteAccountHint: 'La suppression du compte supprimera définitivement toutes vos données.',
      deleteAccount: 'Supprimer le compte',
    },
  },
  post: {
    likes: '{count} j\'aime',
    views: '{count} vues',
    shares: '{count} partages',
    comments: '{count} commentaires',
    save: 'Enregistrer',
    saved: 'Enregistré',
    share: 'Partager',
    linkCopied: 'Lien copié !',
    follow: 'Suivre',
    following: 'Abonné',
    relatedPosts: 'Publications similaires',
    commentPlaceholder: 'Écrire un commentaire...',
    commentLoginPlaceholder: 'Connectez-vous pour commenter...',
    commentSubmit: 'Publier',
    commentSubmitting: 'Publication...',
    noComments: 'Aucun commentaire pour le moment. Soyez le premier !',
    savedToCollection: 'Ajouté à la collection',
    removedFromCollection: 'Supprimé de la collection',
    description: 'Description',
    profileView: 'Voir le profil',
  },
  notifications: {
    title: 'Notifications',
    empty: 'Aucune notification',
    markAllRead: 'Tout marquer comme lu',
    types: {
      like_post: 'a aimé votre photo',
      comment: 'a commenté votre photo',
      reply: 'a répondu à votre commentaire',
      follow: 'vous a suivi',
      approve: 'Votre publication a été approuvée',
      reject: 'Votre publication a été rejetée',
      system: 'Notification système',
    },
  },
  search: {
    title: 'Résultats pour',
    result: 'Résultat',
    tryOtherKeywords: 'Essayez d\'autres mots-clés...',
    noResults: 'Aucun résultat pour',
    placeholder: 'Rechercher...',
    thisHashtag: 'photos avec ce hashtag',
  },
  upload: {
    title: 'Publier une photo',
    dragDrop: 'Glissez-déposez ou cliquez pour sélectionner',
    supportedFormats: 'Formats supportés : JPG, PNG, WebP, GIF',
    submit: 'Publier',
    submitting: 'Publication...',
    titleField: 'Titre',
    titlePlaceholder: 'Entrez un titre accrocheur...',
    descriptionField: 'Description',
    descriptionPlaceholder: 'Description détaillée de l\'ensemble de photos...',
    hashtagsField: 'Hashtags',
    statusField: 'Statut',
    statusPublic: 'Public',
    statusPrivate: 'Privé',
    statusDraft: 'Brouillon',
    error: 'Erreur lors de l\'upload',
    errorSelect: 'Sélectionnez au moins 1 photo',
    errorTitle: 'Entrez un titre',
    photos: 'photos',
    uploading: 'Téléchargement en cours...',
  },
  notFound: {
    title: 'Page introuvable',
    subtitle: "La page que vous recherchez n'existe pas.",
    backHome: "Retour à l'accueil",
  },
  liked: {
    title: 'Publications aimées',
    empty: 'Aucune publication aimée pour le moment.',
  },
  user: {
    unknown: 'Anonyme',
  },
  globalError: {
    title: 'Une erreur est survenue',
    subtitle: 'Désolé pour le désagrément. Veuillez réessayer.',
    retry: 'Réessayer',
  },
  username: {
    posts: 'Publications',
    likes: 'J\'aime',
    followers: 'Abonnés',
    following: 'Abonnements',
    editProfile: 'Modifier le profil',
    message: 'Envoyer un message',
    noPosts: 'Aucune publication pour le moment.',
    bio: 'Voir les photos de ',
    notFound: 'Utilisateur non trouvé',
  },
  topic: {
    notFound: 'Sujet non trouvé',
    viewTitle: 'Voir les photos du sujet ',
  },
  dashboard: {
    title: 'Tableau de bord',
    welcome: 'Bienvenue',
    stats: {
      posts: 'Publications',
      views: 'Vues',
      likes: 'J\'aime',
      comments: 'Commentaires',
    },
  },
  adsblock: {
    title: "Vous utilisez un bloqueur de publicités",
    description: "Veuillez désactiver le bloqueur de publicités pour afficher des images en haute qualité et nous aider à maintenir le site gratuit.",
    action: "Je l’ai désactivé — Recharger",
    cancel: "Ignorer"
  },
  pwa: {
    title: `Installer ${appName} pour une meilleure expérience !`,
    iosSubtitle: `Appuyez sur Partager → Ajouter à l'écran d'accueil`,
    androidSubtitle: `Recevez des notifications sur les nouveaux ensembles de photos dès leur publication`,
    installButton: `Installer ${appName}`,
    disclaimer: `Installation rapide, aucun magasin d'applications requis.`,
  },
  autotrans: {
    title: 'Traduction automatique',
    translated: 'Traduction',
    origin: 'Contenu original',
  },
  subscription: {
    title: 'S\'abonner aux notifications',
    description: 'Recevez des notifications sur les nouveaux ensembles de photos dès leur publication.',
    subscribeButton: 'S\'abonner',
    unsubscribeButton: 'Se désabonner',
    subscribed: 'Vous êtes abonné aux notifications.',
    unsubscribed: 'Vous vous êtes désabonné des notifications.',
    error: 'Une erreur est survenue lors de la mise à jour de votre abonnement. Veuillez réessayer.',
    success_tit: '🎉 Notifications activées !',
    denied_tit: 'Notifications refusées',
    error_tit: 'Une erreur est survenue',
    success_des: 'Vous recevrez des notifications lorsque du nouveau contenu sera disponible.',
    denied_des: 'Vous pouvez les réactiver dans les paramètres de votre navigateur.',
    error_des: 'Veuillez réessayer plus tard.',
    skip: 'Ignorer',
    processing: 'Traitement...',
    noti: 'Activer les notifications',
    rule: 'Afficher uniquement les notifications pour le nouveau contenu.',
    notify_title: `Notifications - ${appName}`,
    notify_body: "La nouvelle galerie a été publiée. Découvrez-la maintenant !",
  },
  contact: {
    title: 'Contactez-nous',
    subtitle: 'Nous serions ravis de vous entendre ! Veuillez remplir le formulaire ci-dessous et nous vous répondrons dès que possible.',
    name: 'Nom',
    email: 'E-mail',
    subject: 'Sujet',
    message: 'Message',
    submitButton: 'Envoyer le message',
    sending: 'Envoi en cours...',
    successTitle: 'Message envoyé !',
    successMessage: 'Merci de nous avoir contactés. Nous vous répondrons sous peu.',
    errorTitle: 'Une erreur s’est produite',
    errorMessage: 'Une erreur est survenue lors de l’envoi de votre message. Veuillez réessayer plus tard.',
    res_time_title: 'Délai de réponse',
    res_time: 'Nous répondons généralement sous 1 à 3 jours ouvrables.',
    report_content: 'Signaler un contenu',
    report_content_hint: ' Pour signaler une publication ou un utilisateur, utilisez le bouton de signalement directement sur le contenu ou sélectionnez « Signaler un contenu » ci-dessus.',
    value_default: 'Sélectionnez un sujet',
    value_general: 'Demande générale',
    value_report: 'Signaler un contenu',
    value_account: 'Problème de compte',
    value_business: 'Affaires / partenariat',
    value_feedback: 'Commentaires et suggestions',
    value_other: 'Autre'
  },
  language: {
    label: 'Langue',
    en: 'English', vi: 'Tiếng Việt', zh: '中文', ja: '日本語',
    ko: '한국어', ar: 'العربية', fr: 'Français', es: 'Español',
    ru: 'Русский',
    hi: 'हिन्दी',
    id: 'Indonesia',
    de: 'Deutsch',
    pt: 'Português',
    it: 'Italiano',
  },
};

export default fr;
